import LazyWrapper from 'bz-core-controls/controls/lazy';
import { lazy } from 'react';
import Routes from './sections/routes';

const VehiclesSidebarIcon = lazy(() => import('./sidebar/vehicles'));
const VehiclesAppointmentSection = lazy(() => import('./sections/appointment/vehicle'));
const SettingsRoutes = lazy(() => import('./sections/settings/routes'));
const LabourMenuItem = lazy(() => import('./sections/settings/labour/menu-item'));
const EstimatesSidebarIcon = lazy(() => import('./sidebar/estimates'));
const JobsheetsSidebarIcon = lazy(() => import('./sidebar/jobsheets'));
const HaynesProSidebarIcon = lazy(() => import('./sidebar/haynes-pro'));

const InvoiceEditDialogVehicleControl = lazy(() => import('./sections/invoices/vehicle-selection'));
const InvoiceHeaderVehicleView = lazy(() => import('./sections/invoices/vehicle-header-item'));
const VehicleRemindersMenuItem = lazy(() => import('./sections/settings/reminders/menu-item'));

const plugins = {
  sidebar: [
    LazyWrapper(VehiclesSidebarIcon),
    LazyWrapper(JobsheetsSidebarIcon),
    LazyWrapper(EstimatesSidebarIcon),
    LazyWrapper(HaynesProSidebarIcon)
  ],
  routes: {
    topLevel: [...Routes],
    settings: {
      menuHeader: [SettingsRoutes]
    }
  },
  appointment: {
    dialog: {
      customer: [VehiclesAppointmentSection]
    }
  },
  settings: {
    finance: {
      menuItem: [LazyWrapper(LabourMenuItem)]
    },
    setup: {
      menuItem: [LazyWrapper(VehicleRemindersMenuItem)]
    }
  },
  invoice: {
    edit: {
      dialog: [LazyWrapper(InvoiceEditDialogVehicleControl)]
    },
    header: {
      items: [LazyWrapper(InvoiceHeaderVehicleView)]
    }
  }
};

export default plugins;
